<div class="element">
    <div class="control-handle-content">
        <div class="wrap-text" style="position: relative">
            <div>
                @if (allVariablesUnfilled(element) && !typeGuards.isTextarea(element)) {
                    <span class="link text-error">
                        {{ "control_choose_variable" | translate }}
                    </span>
                }
                @if (!allVariablesUnfilled(element) && !typeGuards.isTextarea(element)) {
                    <span
                        class="link text-nowrap"
                        [popover]="popTemplate"
                        placement="bottom left"
                        triggers="mouseenter:mouseleave"
                    >
                        @if (someVariableUnfilled(element)) {
                            <span class="sp-icon icon-info text-warning">&nbsp;</span>
                        }
                        @if (element.variable) {
                            <code class="grey-code" style="color: #716064; background-color: #eaeaea">{{
                                element.variable
                            }}</code>
                        }
                        @if (element.value) {
                            <code class="grey-code">{{ element.value }}</code>
                        }
                        @if (element.crmContactVariable) {
                            <code class="grey-code">{{
                                getVariableName(element.crmContactVariable, variableTypes.crmContactAttribute)
                                    | translate
                            }}</code>
                        }
                        @if (element.crmDealVariable) {
                            <code class="grey-code">{{
                                getVariableName(element.crmDealVariable, variableTypes.crmDealAttribute) | translate
                            }}</code>
                        }
                    </span>
                }
                <ng-template #popTemplate>
                    <div class="variables-popup">
                        @if (typeGuards.isSystemElement(element)) {
                            @if (createAddressBook) {
                                <label class="control-label"> {{ "crm_mailing_list_variable" | translate }}: </label>
                                <div>
                                    <code class="grey-code">
                                        {{ element.variable }}
                                    </code>
                                </div>
                            }
                            <ng-container>
                                <label class="control-label"> {{ "crm_contact_variable" | translate }}: </label>
                                <div>
                                    <code class="grey-code">
                                        {{ element.variable }}
                                    </code>
                                </div>
                            </ng-container>
                        }

                        @if (!typeGuards.isSystemElement(element)) {
                            @if (element.type === formInputType.hidden) {
                                <!-- hidden field value-->
                                <label class="control-label"> {{ "control_hidden_value" | translate }}: </label>
                                @if (element.value) {
                                    <div>
                                        <code class="grey-code">
                                            {{ element.value }}
                                        </code>
                                    </div>
                                }
                                @if (!element.value) {
                                    <div class="text-warning small">
                                        {{ "no_value" | translate }}
                                    </div>
                                }
                            }
                            <!-- crm contact variable-->
                            <label class="control-label"> {{ "crm_contact_variable" | translate }}: </label>
                            @if (element.crmContactVariable) {
                                <div>
                                    <code class="grey-code">
                                        {{
                                            getVariableName(
                                                element.crmContactVariable,
                                                variableTypes.crmContactAttribute
                                            ) | translate
                                        }}
                                    </code>
                                </div>
                            }
                            @if (!element.crmContactVariable) {
                                <div class="text-warning small">
                                    {{ "not_selected" | translate }}
                                </div>
                            }
                            <!-- crm deal variable-->
                            @if (!isCrmDealsListDisabled && !hideEmptyDealVariableAlert) {
                                <label class="control-label"> {{ "crm_deal_variable" | translate }}: </label>
                                @if (element.crmDealVariable) {
                                    <div>
                                        <code class="grey-code">
                                            {{
                                                getVariableName(element.crmDealVariable, variableTypes.crmDealAttribute)
                                                    | translate
                                            }}
                                        </code>
                                    </div>
                                }
                                @if (!element.crmDealVariable) {
                                    <div class="text-warning small">
                                        {{ "not_selected" | translate }}
                                    </div>
                                }
                            }
                            @if (createAddressBook) {
                                <!-- address book variable-->
                                <label class="control-label"> {{ "crm_mailing_list_variable" | translate }}: </label>
                                @if (element.variable) {
                                    <div>
                                        <code class="grey-code">
                                            {{ element.variable }}
                                        </code>
                                    </div>
                                }
                                @if (!element.variable) {
                                    <div class="text-warning small">
                                        {{ "not_selected" | translate }}
                                    </div>
                                }
                            }
                        }
                    </div>
                </ng-template>

                @if (typeGuards.isTextarea(element)) {
                    <span
                        class="link text-nowrap"
                        [popover]="popTextareaTemplate"
                        placement="bottom left"
                        triggers="mouseenter:mouseleave"
                    >
                        <code class="grey-code"> Notes </code>
                    </span>
                }
                <ng-template #popTextareaTemplate>
                    {{ getCrmCommentPlaceHint(element) | translate }}
                </ng-template>
            </div>
        </div>
    </div>
</div>
